import {get, post, del, patch} from "../api"
import * as url from "../url"

const apiGetUsersList = data => {
  return get(url.API_USERS, data.history)
}

const apiPostUsersNew = data => {
  return post(url.API_USERS, data.history, data.values)
}

const apiPatchUsersEdit = data => {
  return patch(url.API_USERS + data.id + "/", data.history, data.values)
}

const apiDeleteUsersDelete = data => {
  return del(url.API_USERS + data.id + "/", data.history)
}

const apiGetUsersBlock = data => {
  return get(url.API_USERS + data.id + "/" + data.action, data.history)
}

const apiGetUsersAvatarDetail = data => {
  return get(url.API_USERS + data.id + "/avatar-detail", data.history)
}

const apiGetUsersSelectList = data => {
  return get(url.API_USERS + "select-list/", data.history)
}

export {
  apiGetUsersList,
  apiPostUsersNew,
  apiPatchUsersEdit,
  apiDeleteUsersDelete,
  apiGetUsersBlock,
  apiGetUsersAvatarDetail,
  apiGetUsersSelectList,
}
